<div class="page-container page-containers content-w-98">
  <div class="main-div content-w-98">
    <div class="title-div">
      <div class="headerName">
        <span>Product reporting</span>
      </div>
    </div>
  </div>
  <div [formGroup]="reportChartForm">
    <div class="row">
      <div class="dropdowns-div col-4">
        <div class="subTitleName">
          <span>Chart at a glance</span>
        </div>

        <div class="row scenarios-div">
          <div class="col-12">
            <p class="note-div gray-font">Select up to 6 product to compare</p>
          </div>
          <div class="col-12 ng-select-div reportGenerationDrd chartAtGlanceDrp">
            <label class="labelColor">Products</label>
            <ng-select
              [clearable]="false"
              #products
              formControlName="products"
              placeholder="Products"
              [items]="productList"
              [searchable]="false"
              bindLabel="name"
              bindValue="idStr"
              [searchFn]="commonInputSearchName"
              [multiple]="true"
              (change)="onProductChange($event)"
              [maxSelectedItems]="allowSelectScenario"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    class="search"
                    placeholder="Search..."
                    (input)="products.filter($any($event.target).value)"
                    type="text"
                    class="form-control search-input"
                    id="inputValidation"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                reportChartForm.controls['products']?.touched &&
                reportChartForm.controls['products']?.invalid
              "
              class="input-error"
            >
              Please select products
            </div>
          </div>
        </div>

        <!-- chart type and comparison by -->
        <div class="row">
          <div class="col-6 ng-select-div reportGenerationDrd">
            <label class="labelColor">Chart type</label>
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              #chartTypeTmp
              placeholder="Chart type"
              formControlName="chartType"
              [items]="chartTypeList"
              [searchable]="false"
              bindLabel="description"
              [multiple]="false"
            >
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item.description }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                reportChartForm.controls['chartType']?.touched &&
                reportChartForm.controls['chartType']?.invalid
              "
              class="input-error"
            >
              Please select chart type
            </div>
          </div>
          <div class="col-6 ng-select-div reportGenerationDrd">
            <label class="labelColor">{{ comparisonAndCategoryLabel }}</label>
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              formControlName="comparisonBy"
              #comparisionTmp
              placeholder="{{ comparisonAndCategoryLabel }}"
              [items]="comparisonByList"
              [searchable]="false"
              bindLabel="name"
              class="impactCatDrp"
              [searchFn]="commonInputSearchName"
              [multiple]="false"
              (change)="onComparisonByChange($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control search-input"
                    id="inputValidation"
                    (input)="comparisionTmp.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                reportChartForm.controls['comparisonBy']?.touched &&
                reportChartForm.controls['comparisonBy']?.invalid
              "
              class="input-error"
            >
              Please select comparison by
            </div>
          </div>
        </div>

        <!-- categories to include  -->
        <div class="row" *ngIf="showCategoryToInclude">
          <label class="labelColor">Categories to include</label>
          <div class="col-12 ng-select-div reportGenerationDrd">
            <ng-select
              #category
              [clearable]="false"
              formControlName="categoriesToInclude"
              [items]="categoriesIncludeList"
              placeholder="Categories to include"
              [searchable]="false"
              bindLabel="name"
              bindValue="id"
              [searchFn]="commonInputSearchName"
              [ngClass]="
                reportChartForm.controls['categoriesToInclude'].value?.length > 2
                  ? 'multi-select '
                  : ''
              "
              [multiple]="isCategoryMultipleSelect"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control search-input"
                    (input)="category.filter($any($event.target).value)"
                    id="inputValidation"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                reportChartForm.controls['categoriesToInclude']?.touched &&
                reportChartForm.controls['categoriesToInclude']?.invalid
              "
              class="input-error"
            >
              Please select categories to include
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Functional unit -->
          <div class="col-12 ng-select-div reportGenerationDrd">
            <div class="row">
              <div class="col-12 ng-select-div reportGenerationDrd">
                <label class="labelColor">Functional unit</label>
                <ng-select
                  [clearable]="false"
                  [clearOnBackspace]="false"
                  #fUnit
                  formControlName="functionalUnit"
                  placeholder="Functional unit"
                  [items]="functionalUnitList"
                  [searchable]="false"
                  bindLabel="name"
                  [searchFn]="commonInputSearchName"
                  [multiple]="false"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        placeholder="Search..."
                        type="text"
                        class="form-control search-input"
                        (input)="fUnit.filter($any($event.target).value)"
                        id="inputValidation"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="
                    reportChartForm.controls['functionalUnit']?.touched &&
                    reportChartForm.controls['functionalUnit']?.invalid
                  "
                  class="input-error"
                >
                  Please select functional unit
                </div>
              </div>
              <div class="col-12 reportGenerationDrd" *ngIf="showBaseLineComparison">
                <label class="labelColor">Baseline for functional comparison</label>
                <ng-select
                  [clearable]="false"
                  [clearOnBackspace]="false"
                  formControlName="baselineFunctional"
                  [items]="baseScenarioList"
                  placeholder="Baseline for functional comparison"
                  [searchable]="false"
                  bindLabel="name"
                  #fUnitBase
                  [searchFn]="commonInputSearchName"
                  [multiple]="false"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        placeholder="Search..."
                        type="text"
                        class="form-control search-input"
                        (input)="fUnitBase.filter($any($event.target).value)"
                        id="inputValidation"
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="
                    reportChartForm.controls['baselineFunctional']?.touched &&
                    reportChartForm.controls['baselineFunctional']?.invalid
                  "
                  class="input-error"
                >
                  Please select baseline for functional comparison
                </div>
              </div>
            </div>

            <!-- Buttons -->
          </div>
          <div id="goTOSpiderChat" class="modal-footer">
            <button
              type="submit"
              style="padding-left: 35px"
              class="modelBtn purpleBtnHoverEffect"
              (click)="generateChart()"
            >
              Generate
            </button>
            <button type="button" class="next-btn modelBtn" (click)="nextRoute()">
              Next <i class="bi bi-arrow-right checkbox-div"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="mainChatDiv col-8">
        <div class="canvas">
          <div class="custom-btn-group" *ngIf="isPEFChart">
            <div class="btn-group mr-2" role="group" aria-label="First group">
              <button
                type="button"
                class="btn btn-secondary"
                [ngClass]="
                  selectedPEFType != 'Weighted' ? ' modelBtn  purpleBtnHoverEffect' : 'cancelBtn'
                "
                (click)="changePEFCategories('Normalized')"
              >
                Normalized
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                [ngClass]="
                  selectedPEFType == 'Weighted' ? ' modelBtn  purpleBtnHoverEffect' : 'cancelBtn'
                "
                (click)="changePEFCategories('Weighted')"
              >
                Weighted
              </button>
            </div>
          </div>
          <div *ngIf="chartData?.length > 0 && showChartType == BAR_CHART_ID">
            <div *ngIf="isPEFResults">
              <piqet-angular-bar-chart
                [chartData]="chartData"
                [chartOpacity]="chartOpacity"
                [title]="topIndicatorName"
                [indicatorsName]="indicatorName"
                [chartType]="generatedChartType"
                [selectedPEFType]="selectedPEFType"
                [isChartNormalized]="isChartNormalized"
                (changePEFCategoriesEmit)="changePEFCategories($event)"
              ></piqet-angular-bar-chart>
            </div>
          </div>
        </div>
        <div
          style="height: 500px"
          *ngIf="chartData?.length > 0 && showChartType == SPIDER_CHART_ID"
        >
          <piqet-angular-radar-chart
            [spiderChartData]="chartData"
            [chartOpacity]="chartOpacity"
          ></piqet-angular-radar-chart>
        </div>
      </div>
    </div>
  </div>
</div>
